import {
  initVantivProviderProps,
  initVantivSubmitData,
} from 'constant/VantivConstants';
import { parsePropsToSubmitData } from 'parsers/vantivParsers/vantivParsers';

/**
 * Retrieves the properties for a specific payment provider.
 *
 * @param provider - The payment provider object containing provider details.
 * @returns The properties specific to the payment provider.
 */
export const getPaymentProviderProps = provider =>
  getPaymentProviderFunctions(provider?.paymentProvider).getProps(provider);

/**
 * Retrieves the submit data for a specific payment provider.
 *
 * @param provider - The payment provider object containing provider details.
 * @returns The submit data for the payment provider.
 */
export const getSubmitDataProps = provider => {
  const { getProps, getSubmitData } = getPaymentProviderFunctions(
    provider?.paymentProvider
  );
  const providerProps = getProps(provider);
  return getSubmitData(providerProps);
};

const getPaymentProviderFunctions = paymentProvider =>
  providerFunctionsMap[paymentProvider] || providerFunctionsMap['DEFAULT'];

const providerFunctionsMap = {
  VANTIV: {
    getProps: ({ properties }) => buildProviderProps(properties),
    getSubmitData: providerProps => parsePropsToSubmitData(providerProps),
  },
  DEFAULT: {
    getProps: () => initVantivProviderProps,
    getSubmitData: () => initVantivSubmitData,
  },
};

const buildProviderProps = properties =>
  properties.reduce((obj, { propertyName, propertyValue }) => {
    obj[propertyName] = propertyValue;
    return obj;
  }, {});
